export default {
  '2023': {
    "2023/12/24": "平安夜",
    "2023/12/25": "圣诞节"
  },
  "2024": {
    "2024/1/1": "元旦",
    "2024/2/10": "春节",
    "2024/2/11": "休",
    "2024/2/12": "休",
    "2024/2/13": "休",
    "2024/2/14": "休",
    "2024/2/15": "休",
    "2024/2/16": "休",
    "2024/2/17": "休",
    "2024/2/18": "班",
    "2024/4/4": "清明节",
    "2024/4/5": "休",
    "2024/4/6": "休",
    "2024/5/1": "劳动节",
    "2024/5/2": "休",
    "2024/5/3": "休",
    "2024/5/4": "休",
    "2024/5/5": "休",
    "2024/6/1": "儿童节",
    "2024/6/08": "休",
    "2024/6/09": "休",
    "2024/6/10": "端午节",
    "2024/9/10": "教师节",
    "2024/9/14": "班",
    "2024/9/15": "休",
    "2024/9/16": "休",
    "2024/9/17": "中秋节",
    "2024/10/1": "国庆节",
    "2024/10/2": "休",
    "2024/10/3": "休",
    "2024/10/4": "休",
    "2024/10/5": "休",
    "2024/10/6": "休",
    "2024/10/7": "休",
    "2024/10/12": "班",
    "2024/12/21": "冬至",
    "2024/12/24": "平安夜",
    "2024/12/25": "圣诞节"
  },
  '2025': {
    "2025/1/1": "元旦",
    "2025/1/28": "除夕",
    "2025/1/30": "休",
    "2025/1/31": "休",
    "2025/1/29": "休",
    "2025/2/1": "休",
    "2025/2/2": "休",
    '2025/2/14': '情人节',
    '2025/3/8': '妇女节',
    "2025/4/4": "清明节",
    "2025/4/5": "休",
    "2025/4/6": "休",
    "2025/5/1": "劳动节",
    "2025/5/2": "休",
    "2025/5/3": "休",
    "2025/5/31": "端午节",
    "2025/6/1": "休",
    "2025/6/2": "休",
    "2025/6/15": "父亲节",
    "2025/10/1": "国庆节",
    "2025/10/2": "休",
    "2025/10/3": "休",
    "2025/10/4": "休",
    "2025/10/5": "休",
    "2025/10/6": "中秋节",
    "2025/10/7": "休",
    "2025/12/25": "圣诞节"
  },
  '2026': {
    "2026/1/1": "元旦",
    "2026/2/11": "除夕",
    "2026/2/12": "春节",
    "2026/2/13": "休",
    "2026/2/14": "休",
    "2026/2/15": "休",
    "2026/2/16": "休",
    "2026/2/17": "休",
    "2026/4/5": "清明节",
    "2026/4/6": "休",
    "2026/4/7": "休",
    "2026/5/1": "劳动节",
    "2026/5/2": "休",
    "2026/5/3": "休",
    "2026/6/1": "儿童节",
    "2026/6/26": "端午节",
    "2026/9/10": "教师节",
    "2026/9/19": "休",
    "2026/10/1": "国庆节",
    "2026/10/2": "休",
    "2026/10/3": "休",
    "2026/10/4": "休",
    "2026/10/5": "休",
    "2026/10/6": "休",
    "2026/10/7": "休",
    "2026/12/24": "平安夜",
    "2026/12/25": "圣诞节"
  },
  "2027": {
    "2027/1/1": "元旦",
    "2027/2/17": "除夕",
    "2027/2/18": "春节",
    "2027/2/19": "春节",
    "2027/2/20": "春节",
    "2027/2/21": "春节",
    "2027/2/22": "春节",
    "2027/2/23": "春节",
    "2027/2/24": "春节",
    "2027/4/4": "清明节",
    "2027/4/5": "清明节",
    "2027/4/6": "清明节",
    "2027/5/1": "劳动节",
    "2027/5/2": "劳动节",
    "2027/5/3": "劳动节",
    "2027/6/14": "端午节",
    "2027/9/27": "中秋节",
    "2027/10/1": "国庆节",
    "2027/10/2": "国庆节",
    "2027/10/3": "国庆节",
    "2027/10/4": "国庆节",
    "2027/10/5": "国庆节",
    "2027/10/6": "国庆节",
    "2027/10/7": "国庆节",
    "2027/12/25": "圣诞节"
  }


}
